/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonSharingVisibilityFromJSON, InternalCommonSharingVisibilityToJSON, } from './InternalCommonSharingVisibility';
/**
 * @export
 */
export const InternalCommonCustomAttributeSelectTypeTypeEnum = {
    Select: 'select'
};
/**
 * Check if a given object implements the InternalCommonCustomAttributeSelectType interface.
 */
export function instanceOfInternalCommonCustomAttributeSelectType(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('visibility' in value) || value['visibility'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
export function InternalCommonCustomAttributeSelectTypeFromJSON(json) {
    return InternalCommonCustomAttributeSelectTypeFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeSelectTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'visibility': InternalCommonSharingVisibilityFromJSON(json['visibility']),
        'type': json['type'],
        'value': json['value'],
        'options': json['options'] == null ? undefined : json['options'],
    };
}
export function InternalCommonCustomAttributeSelectTypeToJSON(json) {
    return InternalCommonCustomAttributeSelectTypeToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeSelectTypeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'visibility': InternalCommonSharingVisibilityToJSON(value['visibility']),
        'type': value['type'],
        'value': value['value'],
        'options': value['options'],
    };
}
